import React from 'react';

import "./Header.css";

export const Header = () => {
    return(
        <header className="container-header">
            <h2>Tecnologias e Experiência</h2>
        </header>
    );
};